const communicationChatReload = (flag) => {
  return {
    type: "reload",
    payload: flag,
  };
};

export { communicationChatReload };
